import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { Toaster } from "react-hot-toast";
import { ParallaxProvider } from "react-scroll-parallax";
import { PrivacyPolicy } from "./components/privacy-policy";

import { TermsAndCondition } from "./components/terms-condition";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { useCanonicalUrl } from "./hooks/index";

import { useLocation } from "react-router-dom";
import { ContestRules } from "./components/contest-rules";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div>
          <ParallaxProvider>
            <Toaster />

            <Switch>
              <Route path="/privacy-policy">
                <PrivacyPolicy />
              </Route>

              <Route path="/terms-and-condition">
                <TermsAndCondition />
              </Route>
              <Route path="/contest-rules">
                <ContestRules />
              </Route>
              <Route path="/">
                <Root />
              </Route>
            </Switch>
          </ParallaxProvider>
        </div>
      </Router>
    </HelmetProvider>
  );
};

const Root = () => {
  const [landingPageData, setLandingPageData] = useState({});

  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const canonicalUrl = useCanonicalUrl(["mobile", "app"]);

  const hasDuplicateParam = query.get("") === "sjt" || query.get("") === "pdg";

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        {hasDuplicateParam && <meta name="robots" content="noindex, follow" />}
      </Helmet>
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Contact data={landingPageData.Contact} />
    </React.Fragment>
  );
};

export default App;
